import { amplifyProxy } from '@/services/directApi'

export default {
  namespaced: true,
  state: {
    forecastReports: '',
    loading: false,
    error: null
  },
  mutations: {
    SET_MANAGEMENT_FEE_FORECASTS(state, data) {
      state.forecastReports = data
    },
    SET_LOADING(state, value) {
      state.loading = value
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    async getManagementFeeForecasts({ commit, rootState }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      
      try {
        const endpoint = `/${rootState.user.ClientName}/reporting/fees/forecast`
        const options = {
          headers: {
            token: rootState.user.LoginToken,

          },
          queryStringParameters: {
            branchID: rootState.branchID
          }
        }

        const response = await amplifyProxy.get(endpoint, options)
        // Note: We extract data.Data here to maintain compatibility with the original store
        // which expected a nested Data property in the response
        commit('SET_MANAGEMENT_FEE_FORECASTS', response.data.Data)
        return response.data.Data
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  getters: {
    reports(state) {
      return state.forecastReports || []
    }
  }
}